const lastElement = (collection) =>
  collection[collection.length - 1];

export default lastElement;
